module.exports = __webpack_public_path__ + "7cbf52d15bb65c4e6ba66e2c2b83798e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-25.png
// module id = 1980
// module chunks = 0